import { useMutation, useQueryClient } from '@tanstack/react-query';
import i18next from 'i18next';
import { useServices, useStores } from 'index';
import { Class } from 'types/organization/classes';

type Callbacks = {
  onSuccess?: () => Promise<void> | void;
};

export const useCreateNewClass = (organizationId: string, callbacks?: Callbacks) => {
  const classesService = useServices().classesService;
  const queryClient = useQueryClient();
  const notificationsStore = useStores().notificationStore;

  return useMutation({
    mutationFn: (newClass: Class) => classesService.createNewClassAndUpdate(newClass),
    onSuccess: async () => {
      await Promise.all([queryClient.invalidateQueries({ queryKey: ['organizationClasses', organizationId] })]);
      notificationsStore.addToast('success', i18next.t('AddedNewClass', { ns: 'classPage' }), 'success');
      await callbacks?.onSuccess?.();
    },
    onError: () => notificationsStore.addToast('error', i18next.t('CreateNewClassError', { ns: 'classPage' }), 'error'),
  });
};
